import { isSupportedProductType as isSupported } from '@/util/isSupportedProductType';
import { getBreadcrumbCategoryId } from '@/util/productFullDetailUtil';
import { usePathname } from 'next/navigation';
import { useEffect, useMemo, useState } from 'react';

export const useGalleryItem = (props = {}) => {
  const { item } = props;

  const pathname = usePathname();
  const colorOptions = useMemo(() => (item.show_colors?.total > 0 ? item.show_colors?.items || [] : []), [item]);
  const [selectedShowColorIndex, setSelectedShowColorIndex] = useState(() => {
    const isQueryProductInStock = pathname.includes('product-stock');

    if (isQueryProductInStock) return -1;

    return colorOptions.findIndex(x => x.is_selected === 1);
  });

  const selectedColor = selectedShowColorIndex >= 0 ? colorOptions[selectedShowColorIndex] : null;

  useEffect(() => {
    setSelectedShowColorIndex(-1);

    const isQueryProductInStock = pathname.includes('product-stock');

    if (!isQueryProductInStock && colorOptions.length) {
      setSelectedShowColorIndex(colorOptions.findIndex(x => x.is_selected === 1));
    }
  }, [colorOptions, pathname]);

  const baseImage = (() => {
    if (selectedShowColorIndex === -1) return item.image?.url || '';

    if (colorOptions.length > 0) {
      return colorOptions[selectedShowColorIndex].image || item.image?.url || '';
    }

    return item.image?.url || '';
  })();

  const versionedBaseImage = (() => {
    if (baseImage) {
      const version = item.version;

      if (!version) {
        return baseImage;
      }

      if (baseImage.indexOf('?') > -1) {
        return `${baseImage}&version=${version}`;
      }

      return `${baseImage}?version=${version}`;
    }

    return null;
  })();

  const hoverImage = (() => {
    if (selectedShowColorIndex === -1) return item.hover_image || '';

    if (colorOptions.length > 0) {
      return colorOptions[selectedShowColorIndex]?.hover_image || item.hover_image || '';
    }

    return item.hover_image;
  })();

  const versionedHoverImage = (() => {
    if (hoverImage) {
      const version = item.version;

      if (!version) {
        return hoverImage;
      }

      if (hoverImage.indexOf('?') > -1) {
        return `${hoverImage}&version=${version}`;
      }

      return `${hoverImage}?version=${version}`;
    }

    return null;
  })();

  const handleLinkClick = () => {
    // google 跟踪代码
    if (item) {
      try {
        let categoryName = props.categoryName;
        if (!categoryName) {
          const breadcrumbCategoryId = getBreadcrumbCategoryId(item?.categories);
          const breadcrumbCategory =
            item?.categories?.find(c => c.uid === breadcrumbCategoryId) ||
            item?.categories?.[item?.categories?.length - 1];
          categoryName = breadcrumbCategory?.name || '';
        }

        window.dataLayer &&
          window.dataLayer.push({
            ecommerce: null,
          });
        const payload = {
          event: 'select_item',
          ecommerce: {
            item_list_name: categoryName, // 明确指出这是男鞋分类页
            item_list_id: categoryName,
            items: [
              {
                item_name: item.name,
                item_id: item.sku,
                price:
                  item?.price_range?.minimum_price?.final_price?.value ||
                  item?.price_range?.maximum_price?.final_price?.value,
                quantity: 1,
                item_category: categoryName,
              },
            ],
          },
        };
        console.log('====== select_item event payload ======', payload);
        window.dataLayer && window.dataLayer.push(payload);
      } catch (err) {
        console.error(err);
      }
    }
  };

  const allColorCount = item.show_colors?.total || 0;
  const productLink = `/${item.url_key}.html`;
  const productType = item ? item.__typename : null;
  const isSupportedProductType = isSupported(productType);

  return {
    ...props,
    handleLinkClick,
    isSupportedProductType,
    baseImage,
    versionedBaseImage,
    hoverImage,
    versionedHoverImage,
    colorOptions,
    allColorCount,
    selectedColor,
    setSelectedShowColorIndex,
    selectedShowColorIndex,
    productLink,
  };
};
